/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  orgData: {},
  organizationSlug: 'default',
  alexUsers: [],
  myOrganizations: {},
  customRouteTitle: null,
  employees: [],
  organizationConfiguration: {},
  activeResumeBatchId: null,
  activeBatchProgress: 0,
  resumeBatchStatus: null,
  resumeBatchStartTime: null,
}